/* eslint-disable class-methods-use-this, prefer-destructuring, no-use-before-define, no-shadow */
class Header {
  constructor() {
    this.header = document.getElementById("header");
    if (this.header) {
      this.init();
    }
  }

  init() {
    this.cloneContactMobile();
    this.headerScroll();
    this.menu();
    this.searchForm();
  }

  headerScroll() {
    const header = this.header;
    const headerHeight = header.offsetHeight + 60;
    let distanceToTop = document.documentElement.scrollTop;

    function callback() {
      const newDistanceToTop = document.documentElement.scrollTop;

      if (newDistanceToTop <= headerHeight) {
        header.classList.remove("scrolled", "scrolled--show");
      } else if (
        newDistanceToTop < distanceToTop &&
        newDistanceToTop > headerHeight
      ) {
        header.classList.add("scrolled--show");
      } else {
        header.classList.add("scrolled");
        header.classList.remove("scrolled--show");
      }
      distanceToTop = newDistanceToTop;
    }

    function throttle(callback, wait = 100) {
      let timer = null;

      return (args) => {
        if (timer === null) {
          timer = setTimeout(() => {
            callback.apply(this, args);
            timer = null;
          }, wait);
        }
      };
    }

    // Scroll event listener
    window.addEventListener("scroll", throttle(callback, 200));

    if (distanceToTop > 0) {
      header.classList.add("scrolled");
    }
  }

  menu() {
    const body = document.body;
    const mobileMenuToogler = document.getElementById("main-menu-toggler");
    const subMenusParentTitles = document.getElementsByClassName(
      "menu-item-parent--title"
    );

    function blockScroll() {
      if (!this.classList.contains("menu-item-has-children")) {
        if (body.classList.contains("u-mobile-block-scroll")) {
          document.body.classList.remove("u-mobile-block-scroll");
        } else {
          document.body.classList.add("u-mobile-block-scroll");
        }
      }
    }

    // Menu button event listener("main-menu-toggler");
    if (mobileMenuToogler) {
      mobileMenuToogler.addEventListener("click", blockScroll);
    }

    // Show sub menus parent titles
    Array.prototype.forEach.call(subMenusParentTitles, (el) => {
      const subMenuParentTitle = el;
      const subMenu = subMenuParentTitle.previousSibling.previousSibling;
      const defaultSubMenuParentTitle = subMenuParentTitle.innerHTML;
      subMenu.appendChild(subMenuParentTitle);
      subMenuParentTitle.style.display = "block";

      // Change sub menu title when sub menu item hover
      Array.prototype.forEach.call(subMenu.children, (el) => {
        const subMenuItem = el;
        if (subMenuItem.tagName === "LI") {
          subMenuItem.addEventListener(
            "mouseover",
            () => {
              subMenuParentTitle.innerHTML = `<span>${subMenuItem.textContent}</span>`;
              subMenuParentTitle.classList.add("menu-item-arrow");
            },
            false
          );
          subMenuItem.addEventListener(
            "mouseout",
            () => {
              subMenuParentTitle.innerHTML = defaultSubMenuParentTitle;
              subMenuParentTitle.classList.remove("menu-item-arrow");
            },
            false
          );
          subMenuItem.addEventListener(
            "click",
            () => {
              subMenuParentTitle.classList.add("menu-item-arrow--click");
              setTimeout(() => {
                subMenu.style.pointerEvents = "none";
                subMenuParentTitle.classList.remove("menu-item-arrow--click");
              }, 300);
            },
            false
          );
        }
      });

      // Restore menu pointerEvents
      subMenu.addEventListener(
        "mouseout",
        () => {
          subMenu.style.pointerEvents = "auto";
        },
        false
      );
    });

    // active menu mobile
    function toggleItem(elem) {
      for (let i = 0; i < elem.length; i += 1) {
        elem[i].addEventListener("click", function (e) {
          const current = this;
          for (let j = 0; j < elem.length; j += 1) {
            if (current !== elem[j]) {
              elem[j].classList.remove("active");
            } else if (current.classList.contains("active") === true) {
              current.classList.remove("active");
            } else {
              current.classList.add("active");
            }
          }
          e.preventDefault();
        });
      }
    }
    toggleItem(
      document.querySelectorAll(
        ".header__menu-container__list  .menu-item-has-children"
      )
    );
  }

  searchForm() {
    const body = document.body;
    const header = this.header;
    const searchFormButton =
      document.getElementsByClassName("js-search-button")[0];
    const searchForm = document.getElementsByClassName(
      "search-form--header"
    )[0];
    const searchFormInput =
      document.getElementsByClassName("search-form__input")[0];

    function showSearchForm(form) {
      const searchForm = form;
      body.classList.add("searchForm");
      header.classList.add("scrolled--show");
      header.classList.add("scrolled");
      searchForm.style.display = "block";
      searchForm.setAttribute("aria-expanded", "true");
      searchFormInput.focus();
      // searchFormButton.style.pointerEvents = "none";
    }

    function hideSearchForm() {
      searchForm.style.display = "none";
      body.classList.remove("searchForm");
      header.classList.remove("scrolled--show");
      header.classList.remove("scrolled");
      searchForm.setAttribute("aria-expanded", "false");
      // searchFormButton.style.pointerEvents = "auto";
    }

    function searchFormToggle(event) {
      event.preventDefault();

      if (searchForm.style.display === "block") {
        hideSearchForm();
      } else {
        showSearchForm(searchForm);
        // searchFormInput.addEventListener("blur", hideSearchForm, true);
      }
    }

    // Toggle search form
    if (searchFormButton && searchForm && searchFormInput) {
      // Toggle search form when clicking search button
      searchFormButton.addEventListener("click", searchFormToggle);

      // Hide search form when clicking outside or when tabbing or escaping out of the search bar.
      // searchFormInput.addEventListener("blur", hideSearchForm, true);
      searchFormInput.addEventListener("keydown", (event) => {
        // Esc: 27.
        if (event.keyCode === 27) {
          hideSearchForm();
        }
      });
    }
  }

  cloneContactMobile() {
    const liContact = document.querySelector(".header__right-menu .menu li");
    const liMenu = document.querySelector(".header__menu-container__list");
    if (liContact) {
      liContact.classList.add("contact-header");
      const liContactClone = liContact.cloneNode(true);
      const getWidth = () => {
        const w = window.innerWidth;
        if (w < 1096) {
          liMenu.appendChild(liContactClone);
        }
      };

      window.addEventListener("resize", getWidth);
      getWidth();
    }
  }
}

export default Header;
